'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * @param nonce - Optional CSP nonce. When provided, next-themes stamps it on
 *   the inline FOUC script + style elements it injects. Required under an
 *   enforced `script-src 'nonce-…' 'strict-dynamic'` policy — without it, the
 *   inline boot script is refused and themes flash on first paint.
 */
export function ThemeProvider(t0) {
  const $ = _c(5);
  const {
    children,
    nonce
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="bg-background text-foreground">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== nonce || $[3] !== t1) {
    t2 = <NextThemesProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true} nonce={nonce}>{t1}</NextThemesProvider>;
    $[2] = nonce;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}